import Link from "next/link";
import { Container } from "react-bootstrap";
import { toWebp } from "../../../utils/common";
import styles from "./style.module.scss";
import { useEffect, useRef } from "react";
import HocButton from "../../HigherOrderComponent/HocButton";



const Cta = (props) => {
	const { data } = props;

	const divRef = useRef(null);

	const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

	useEffect(() => {
		const imageUrl = toWebp(baseUrl + data?.image?.data?.attributes?.url);
		divRef.current.style.backgroundImage = `url(${imageUrl})`;
	}, [data, baseUrl]);



	return (
		<section
			ref={divRef}

			className={`${styles["home-banner-section"]} ${styles["cta-section-new"]} blue-bg-margin`}
		>
			<Container className={styles["container"]}>

			<div className={` ${styles["cta-btn-row"]} row align-items-center`}>
				<div className="col-12 col-xl-8">
					<h2 className="text-white">{data.title}</h2>
				</div>
				<div className="col-12 col-xl-4">
					{data?.button?.id ?
						<div  className={`${styles["hire-btn-mobile"]} hire-btn`} >
							<HocButton
								button={data?.button}
								btnAction={() => HandleClick()}
							>
								<Link
									href={data?.button?.href}
									className="btn btn-secondary decoration-none text-info  "
									
								>
									{data?.button?.label}
								</Link>
							</HocButton>
						</div>
						: null}
				</div>
			</div>




			</Container>
		</section>
	);
};

export default Cta;
